export default __webpack_public_path__ + "44bc5dd47da36a95538f778f026714c5.png";